module.exports = __webpack_public_path__ + "img/DNADamage-BLCA_GSE171351.1bd96790.png";